"use client";

import React from "react";

import { Card, CardContent } from "./ui/card";
import { SecuredFooter } from "./ui/secured-footer";
import logo from "../assets/images/80eight/88-footer-white.svg";
import bgVideo from "../assets/images/loader.mp4";

const PaymentLoader = () => {
  return (
    <Card className="w-full bg-white rounded-2xl border border-[#EBE9EF] !shadow-none relative overflow-hidden">
      <CardContent className="px-6 py-12 w-full">
        <div className="flex items-center justify-center min-h-[400px] relative">
          {/* Video background */}
          <video
            src={bgVideo}
            autoPlay
            loop
            muted
            playsInline
            className="w-[500px] h-[500px] object-contain"
          />

          {/* Logo overlay */}
          <img
            src={logo}
            alt="80eight"
            className="absolute z-10 w-[160px] h-auto top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          />
        </div>
      </CardContent>

      <SecuredFooter />
    </Card>
  );
};

export default PaymentLoader;
